import { Icon } from '@iconify/react';
import appleFilled from '@iconify/icons-ant-design/apple-filled';
import pieChart from '@iconify/icons-ant-design/pie-chart-fill';
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
// utils
import { Component, useContext } from 'react';
import { fShortenNumber } from '../../../utils/formatNumber';
import { UserContext } from '../../Context/UserContext';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
    theme.palette.info.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

export default function AppNewUsers({ user }) {
  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={pieChart} width={44} height={44} />
      </IconWrapperStyle>
      <Typography variant="h3">{fShortenNumber(user.totalBatchNumber)} Batch(s)</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Nombre total de Batch
      </Typography>
    </RootStyle>
  );
}
